export default "__VITE_PUBLIC_ASSET__47891375__"